export default "__VITE_ASSET__2fOoy1fq__"